export const environment = {
	production: false,
	/** O ambiente de desenvolvimento é o `.dev` — produção é sem sufixo. */
	apiUrl: 'https://api.dev.nexpo.soft2code.com',
	/** O app do visitante neste ambiente. A feira é a raiz: `/{slug}`. */
	visitorUrl: 'https://dev.nexpo.soft2code.com',
	/** O site público da plataforma: termos e documentos vivem lá, nos dois ambientes. */
	publicSiteUrl: 'https://nexpoevents.com',
	/**
	 * Liga os adaptadores em memória para os módulos que a API ainda não tem.
	 * Ver `nexpo-web-library/docs/08-REQUISITOS-BACKEND.md`.
	 *
	 * Enquanto isto for `true`, cada tela que roda sobre memória exibe a tarja
	 * de dados de demonstração — ninguém pode confundir número simulado com o
	 * número real da feira.
	 */
	useMockData: true,
} as const;
